
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectTeamIndex } from '../../store/user/user.selector.js';
import { selectGradientData } from '../../store/system/system.selector.js';

// components
import PrimaryBtn from '../../components/btns/primary-btn/PrimaryBtn';
import GradientBG from '../../components/gradient-bg/GradientBG';
import CylinderCardBackground from '../../components/cylinder-card-background/CylinderCardBackground';

// styles
import {
    RouteNotFoundContainer, Content, MessageContainer, ErrorCode, ErrorMessage, ButtonContainer, MainGradientBGContainer } from './RouteNotFound.styles';

export default function RouteNotFound() {
  const location = useLocation();
  const navigate = useNavigate();
  const teamIndex = useSelector(selectTeamIndex);
  const gradientData = useSelector(selectGradientData);

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <RouteNotFoundContainer>
      <Content>
        <MessageContainer className='panel-bg'>
          <ErrorCode>404</ErrorCode>
          <ErrorMessage>
            Cannot find "{location.pathname}"
          </ErrorMessage>
          <ButtonContainer>
            <PrimaryBtn 
              title="GO HOME" 
              onClick={handleGoHome}
            />
          </ButtonContainer>
        </MessageContainer>
      </Content>
      <CylinderCardBackground 
        numColumns={8}
        cardsPerColumn={8}
        radius={600}
        arcDegrees={180}
        speed={24}
        opacity={0.55}
      />
      <MainGradientBGContainer>
        <GradientBG setGradient={gradientData[teamIndex]} />
      </MainGradientBGContainer>
    </RouteNotFoundContainer>
  );
}
